var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.migrations,"item-key":"pk","headers":_vm.headers},scopedSlots:_vm._u([{key:"item.migration_date",fn:function({ item }){return [_vm._v(" "+_vm._s(item.migration_date ? _vm.dateToMonth(item.migration_date) : "-")+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }